module.exports = __webpack_public_path__ + "img/20.5ca20a8d.jpg";